import _slicedToArray from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import _classCallCheck from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _construct from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/construct";
import _toConsumableArray from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.assign";
import e, { isValidElement as r, createElement as t, Fragment as n, Component as o, useRef as c, useState as l, useEffect as s } from "react";
import { transform as u } from "sucrase";

function d() {
  return d = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }, d.apply(this, arguments);
}

var p = /^export default(?=\s+)/m,
    a = /^render(?=\s*\([^)])/m,
    i = /^</,
    m = function m(o) {
  var c = o.code,
      l = o.scope,
      s = c.trim();
  if (!s) return null;

  var m = function (e) {
    return u(e, {
      transforms: ["jsx", "typescript"],
      production: !0
    }).code;
  }(function (e) {
    return p.test(e) ? e.replace(p, "return") : a.test(e) ? e.replace(a, "return") : (e = e.replace(/;$/, ""), i.test(e) && n && (e = "<>" + e + "</>"), "return (" + e + ")");
  }(s)),
      v = function (e, r) {
    var t = Object.keys(r),
        n = t.map(function (e) {
      return r[e];
    });
    return _construct(Function, _toConsumableArray(t).concat([e])).apply(void 0, _toConsumableArray(n));
  }(m, d({
    React: e
  }, l));

  return r(v) ? v : "function" == typeof v ? t(v) : null;
};

var v =
/*#__PURE__*/
function (_o) {
  _inherits(v, _o);

  function v() {
    var _this;

    _classCallCheck(this, v);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(v).apply(this, arguments)), _this.state = {
      element: null,
      error: null,
      prevCode: null
    };
    return _this;
  }

  _createClass(v, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var e, r, t;
      null == (e = (r = this.props).onRendered) || e.call(r, null == (t = this.state.error) ? void 0 : t.toString());
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(e) {
      return e.code !== this.props.code;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var e, r, t;
      null == (e = (r = this.props).onRendered) || e.call(r, null == (t = this.state.error) ? void 0 : t.toString());
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.error ? null : this.state.element;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(e, r) {
      if (r.prevCode === e.code) return null;

      try {
        return {
          element: m(e),
          error: r.error && e.code !== r.prevCode ? null : r.error,
          prevCode: e.code
        };
      } catch (r) {
        return {
          element: null,
          error: r.toString(),
          prevCode: e.code
        };
      }
    }
  }, {
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(e) {
      return {
        error: e.toString()
      };
    }
  }]);

  return v;
}(o);

var f = function f(e) {
  var r = e.code,
      n = e.scope,
      o = e.disableCache;
  var u = c(!0),
      d = c(null),
      p = c(n);
  p.current = n;

  var _l = l(function () {
    var e = t(v, {
      code: r,
      scope: p.current,
      onRendered: function onRendered(r) {
        r ? i({
          element: o ? null : d.current,
          error: r
        }) : d.current = e;
      }
    });
    return {
      element: e,
      error: null
    };
  }),
      _l2 = _slicedToArray(_l, 2),
      a = _l2[0],
      i = _l2[1];

  return s(function () {
    if (u.current) return void (u.current = !1);
    var e = t(v, {
      code: r,
      scope: p.current,
      onRendered: function onRendered(r) {
        r ? i({
          element: o ? null : d.current,
          error: r
        }) : d.current = e;
      }
    });
    i({
      element: e,
      error: null
    });
  }, [r, o]), a;
};

export { v as Runner, m as generateElement, f as useRunner };